import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../utils/formats';

import {
  StyledWrapper,
  StyledNumber,
  StyledLogo,
  StyledName,
  StyledData,
  StyledRankingIcon
} from './style';

import { CHANNELS_ICON_RANKING } from '../../../constants/channels';

const Ranking = ({ data }) => (
  <Fragment>
    {data.map((program, index) => (
      <StyledWrapper key={program.id}>
        <StyledNumber>{index + 1}</StyledNumber>
        {CHANNELS_ICON_RANKING[program.cadena] && (
          <StyledLogo>
            <StyledRankingIcon
              svg={CHANNELS_ICON_RANKING[program.cadena].icon}
            />
          </StyledLogo>
        )}
        <StyledName>{program.emision}</StyledName>
        <StyledData>{formatNumber.new(program.miles)}</StyledData>
        <StyledData>{formatNumber.new(program.indiceTelevisivo)}</StyledData>
      </StyledWrapper>
    ))}
  </Fragment>
);

Ranking.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      cadena: PropTypes.string,
      emision: PropTypes.string,
      miles: PropTypes.number,
      indiceTelevisivo: PropTypes.number
    })
  ).isRequired
};

export default Ranking;
